module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/commit-60de0981b1b72df47a5b6911e18f625e.svg";